import { ContextualMenuButton } from 'app/design/icons/contextual-menu-button';
import { Box, Column, Row } from 'app/design/primitives/box';
import { PCImage } from 'app/design/primitives/image';
import { Text } from 'app/design/primitives/text';
import { useUser } from 'app/network/user';
import { type ChatUser } from 'app/types/chat';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconCrown } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

const theme = createDSTheme();

export function MemberRow({ member, onPress, isAdmin }: { member: ChatUser; onPress?: () => void; isAdmin: boolean }) {
  const { t } = useTranslation('one-channel');
  const { data: currentUser } = useUser();
  const isYou = member.user_id === currentUser?.id;
  return (
    <Pressable onPress={onPress}>
      <Row
        alignItems="center"
        backgroundColor="surface.tertiary-neutral"
        borderRadius="radius.md"
        gap="spacing.general.x2"
        padding="spacing.general.x3"
      >
        {member.profile_url ? (
          <PCImage aspectRatio={1} height={50} source={{ uri: member.profile_url }} style={{ borderRadius: 25 }} />
        ) : (
          <Box backgroundColor="surface.disabled" borderRadius="radius.xl" height={50} width={50} />
        )}
        <Column>
          <Row alignItems="center" gap="spacing.general.x1">
            <Text fontWeight="600" fontSize={16} numberOfLines={1}>
              {member.nickname}
            </Text>
            {isAdmin ? (
              <Column
                borderRadius="radius.full"
                style={{
                  backgroundColor: theme.colors['surface.tertiary'],
                  paddingHorizontal: theme.spacing['spacing.general.x1'],
                  paddingVertical: theme.spacing['spacing.general.x1'],
                }}
              >
                <IconCrown strokeWidth={ICON_STROKE_WIDTH} size={16} color={theme.colors['text.primary']} />
              </Column>
            ) : null}
          </Row>
          <Row>
            {isAdmin ? (
              <Text fontSize={12} color="text.placeholder">
                {t('admin')}
              </Text>
            ) : null}
            {isYou ? (
              <Text fontSize={12} color="text.placeholder">
                {`${isAdmin ? ' | ' : ''}${t('isYou')}`}
              </Text>
            ) : null}
          </Row>
        </Column>
        {Boolean(onPress) ? (
          <Pressable onPress={onPress} style={{ marginLeft: 'auto' }}>
            <ContextualMenuButton dotSize={4} color={theme.colors['text.secondary']} />
          </Pressable>
        ) : null}
      </Row>
    </Pressable>
  );
}
